var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoardEnabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6044_35815)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H40V40H0V0ZM10 8C8.89543 8 8 8.89543 8 10V25.2C8 26.3046 8.89543 27.2 10 27.2H30C31.1046 27.2 32 26.3046 32 25.2V10C32 8.89543 31.1046 8 30 8H10ZM23.7371 16.2286L21.3713 13.8629L15.7099 19.5295C15.1942 20.0452 14.8131 20.6797 14.6002 21.3773L14.0094 23.3126C13.9592 23.4772 14.1187 23.6419 14.2872 23.5904L16.2226 22.9995C16.92 22.7866 17.5544 22.4056 18.07 21.89L23.7371 16.2286ZM25.707 12.8387L24.7613 11.8929C24.3707 11.5024 23.7374 11.5023 23.3468 11.8929L22.3399 12.9029L24.6971 15.26L25.7757 14.1773C26.0961 13.7844 26.0732 13.2049 25.707 12.8387ZM12.2 31C12.2 31.5523 12.6478 32 13.2 32H13.6C14.1523 32 14.6 31.5523 14.6 31V29.6H26V31C26 31.5523 26.4477 32 27 32H27.4C27.9523 32 28.4 31.5523 28.4 31V28.4H26H14.6H12.2V31Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6044_35815"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 12,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoardEnabled);
export default __webpack_public_path__ + "static/media/board_enabled.95806978bff885f0ed49b0b45f4d65ca.svg";
export { ForwardRef as ReactComponent };